import { constants } from "@newsela/angelou";

import { pollOptionTextCss } from "../PollOptions.style";

const { colors } = constants;

export const staticRadioButtonCss = {
  border: `1px solid ${colors.ui.neutral[500]}`,
  borderRadius: "50%",
  display: "inline-block",
  maxHeight: "18px",
  maxWidth: "18px",
  minHeight: "18px",
  minWidth: "18px",
};

export const staticPollOptionTextCss = [
  {
    border: `1px solid ${colors.ui.neutral[400]}`,
    marginLeft: "16px",
  },
  pollOptionTextCss,
];
